// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"007b5ca1","177":"13bd89a7","237":"15210e6c","510":"b578aad0","530":"8da66acb","692":"04adbfcf","698":"836128a3","807":"bc7989ed"}[chunkId] + ".chunk.js";
};